import React from "react";
import {
  parseAmount,
  CURRENCY_EURO,
  invoiceColorState,
  addHtmlElementClass,
  removeHtmlElementClass,
  scrollHtmlElementIntoView,
  isDefined
} from "../../utils/utils";
import I18n from "i18n-js";




// Etichette di riepilogo di una nota di credito, come quelle delle fatture in InvoicesList: emissione, fattura stornata,
// data del rimborso (solo per le note pagate), importo e download del PDF
const CreditNoteDetails = ({
 creditNote,
 isSuperMiddleman
}) => {

  return (
    // Su desktop (lg in su) le pillole stanno sempre su una riga sola: rispetto alle fatture c'e' una pillola in piu' (la
    // data del rimborso), per cui le etichette compaiono solo da xxl (1440px), dove c'e' spazio per tutte, e tra lg e xxl
    // restano compatte, piu' vicine tra loro
    <div className="d-flex justify-content-end flex-wrap flex-lg-nowrap align-items-center px-0 px-md-2">
      {/* Aggregatore della nota, per i super-aggregatori. A differenza delle fatture (classe middleman-label, da 1440px)
          compare solo da xxxl (1680px), dove accanto alle altre cinque pillole c'e' spazio, e il nome lungo si tronca
          (intero nel tooltip): con le pillole su una riga sola non deve mai sforare */}
      {
        isSuperMiddleman && creditNote.middleman &&
          <div
            className="d-none d-xxxl-flex justify-content-center text-center align-items-center bg-aiG-gray2-imp br-50px ml-1 ml-lg-2 mr-0 mr-md-1 px-2 py-1 my-1"
            title={creditNote.middleman}>
            <span className="text-truncate" style={{ maxWidth: '150px' }}>{creditNote.middleman}</span>
          </div>
      }

      {
        creditNote.emitted_at &&
          <div
            className="bg-aiG-gray2-imp br-50px ml-1 ml-lg-2 mr-0 mr-md-1 px-2 py-1 my-1 d-flex justify-content-center text-center align-items-center">
            <img src={window.location.origin + '/images/icons/small/calendar.svg'}
                 alt="" width="15" height="15" className="mr-2"/>
            <span className="d-flex d-sm-none">{I18n.t('js.indexCreditNotes.emissionDateCompact')}:&nbsp;</span>
            <span className="d-none d-sm-flex d-lg-none d-xxl-flex">{I18n.t('js.indexCreditNotes.emissionDate')}:&nbsp;</span>
            <b>{creditNote.emitted_at}</b>
          </div>
      }

      <div
        className="bg-aiG-gray2-imp br-50px ml-1 ml-lg-2 mr-0 mr-md-1 px-2 py-1 my-1 d-flex justify-content-center text-center align-items-center">
        <img src={window.location.origin + '/images/icons/contract.svg'}
             alt="" width="15" height="15" className="mr-2"/>
        <span className="d-flex d-lg-none d-xxl-flex">{I18n.t('js.indexCreditNotes.creditedInvoice')}:&nbsp;</span>
        <b>{creditNote.invoice.number}</b>
      </div>

      {
        creditNote.paid_at &&
        <div
          className="bg-aiG-gray2-imp br-50px ml-1 ml-lg-2 mr-0 mr-md-1 px-2 py-1 my-1 d-flex justify-content-center text-center align-items-center">
          <img src={window.location.origin + '/images/icons/small/calendar.svg'}
               alt="" width="15" height="15" className="mr-2"/>
          <span className="d-flex d-lg-none d-xxl-flex">{I18n.t('js.indexCreditNotes.refundDate')}:&nbsp;</span>
          <b>{creditNote.paid_at}</b>
        </div>
      }

      {
        creditNote.amount &&
        <div
          className="bg-aiG-gray2-imp br-50px ml-1 ml-lg-2 mr-0 mr-md-1 px-2 py-1 my-1 d-flex justify-content-center text-center align-items-center">
          <img src={window.location.origin + '/images/icons/small/money.svg'}
               alt="" width="15" height="15" className="mr-2"/>
          <span className="d-flex d-lg-none d-xxl-flex">{I18n.t('js.indexCreditNotes.amount')}:&nbsp;</span>
          <b>{parseAmount(creditNote.amount, 2, true)}{CURRENCY_EURO}</b>
        </div>
      }

      <div
        className="bg-intense-blue-imp br-50px ml-1 ml-lg-2 mr-0 mr-md-1 px-2 py-1 my-1 d-flex justify-content-center text-center align-items-center">
        <a href={creditNote.credit_note_link} className="d-flex justify-content-center align-items-center text-center text-white">
          <img src={window.location.origin + '/images/icons/white/download-pdf.svg'}
               alt="" width="15" height="15" className="mr-2"/>
          <span>{I18n.t('js.indexCreditNotes.download').toUpperCase()}</span>
        </a>
      </div>
    </div>
  )
}


// Elenco delle note di credito del frontoffice, sulla falsariga di InvoicesList: ogni nota si espande mostrando le
// sue voci. A differenza delle fatture non ci sono scadenze ne' tranche di pagamento: la nota si rimborsa per intero
const CreditNotesList = ({
   creditNotes,
   setCreditNotes,
   isSuperMiddleman
 }) => {

  // Funzione che verifica se una certa nota di credito ha le sue voci
  const creditNoteRowsPresent = (creditNote) => {
    return creditNote.credit_note_rows?.length > 0;
  }


  // Funzione che aggiorna una determinata nota di credito sull'interfaccia grafica
  const handleChangeCreditNoteParams = (creditNote) => {
    let newCreditNotes = creditNotes.map((c) => {
      return c.id === creditNote.id ? { ...creditNote } : c
    });
    setCreditNotes(newCreditNotes)
  }


  // Funzione che gestisce il rendering sull'interfaccia grafica della freccia che indica all'utente la possibilità
  // di espandere / compattare una nota di credito sulla vista
  const handleDisplayCreditNoteArrowDown = (creditNote, display) => {
    if (creditNoteRowsPresent(creditNote)) {
      if (window.innerWidth >= 768) {
        removeHtmlElementClass(document, `credit_note_number_container_${creditNote.id}`, 'px-md-1');
        removeHtmlElementClass(document, `credit_note_number_container_${creditNote.id}`, 'px-md-0');
        removeHtmlElementClass(document, `credit_note_number_container_${creditNote.id}`, 'px-xxxl-2');
        removeHtmlElementClass(document, `credit_note_number_container_${creditNote.id}`, 'px-xxxl-0');

        if (display) {
          addHtmlElementClass(document, `credit_note_number_${creditNote.id}`, 'd-none');
          removeHtmlElementClass(document, `credit_note_arrow_down_${creditNote.id}`, 'd-none');
        } else {
          removeHtmlElementClass(document, `credit_note_number_${creditNote.id}`, 'd-none');
          addHtmlElementClass(document, `credit_note_arrow_down_${creditNote.id}`, 'd-none');
          addHtmlElementClass(document, `credit_note_number_container_${creditNote.id}`, 'px-md-1');
          addHtmlElementClass(document, `credit_note_number_container_${creditNote.id}`, 'px-xxxl-2');
        }
      }
    }
  }


  return (
    <div className="row w-100 p-0 mx-0 mt-0 mb-5">
      {creditNotes.map((creditNote) =>
        <div key={creditNote.id} id={`credit_note_${creditNote.id}`}
             className="invoice_container col-12 d-block d-md-flex my-3 px-3 px-md-0"
        >
          {
            creditNoteRowsPresent(creditNote) &&
              <div className="d-flex d-md-none align-items-start justify-content-start pb-2 px-2">
                <img
                  src={window.location.origin + `/images/icons/blue/arrow-${creditNote.display_content ? 'up' : 'down'}.svg`}
                  alt="" width="18px"
                  onClick={() => {
                    handleChangeCreditNoteParams({
                      ...creditNote,
                      display_content: !creditNote.display_content
                    })
                    if (!creditNote.display_content)
                      setTimeout(() => scrollHtmlElementIntoView(document, `credit_note_${creditNote.id}_content`, false), 2 * (600 / 3))
                  }}/>
              </div>
          }

          <div className="w-100 p-0">
            <div
              className={`row w-100 p-0 m-0 align-items-center border-aiG-light-gray-imp br-8px
              ${creditNote.display_content ? 'bg-lg-aig-light-gradient' : (creditNoteRowsPresent(creditNote) ? 'on-hover-bg-lg-aig-light-gradient' : '')}`}>
              {/* Da lg la colonna del numero si stringe a 1/12, come da xl: alle pillole, che stanno su una riga sola,
                  serve tutto lo spazio della colonna centrale */}
              <div className={`col-5 col-md-2 col-lg-1 bg-aig-gradient color-white
                d-flex justify-content-center justify-content-md-center align-items-center
                px-0 px-md-1 px-xxxl-2 minH-40px-imp z-index-10
                ${creditNoteRowsPresent(creditNote) ? 'cursor-pointer' : ''}
                br-top-left-8px br-bottom-left-0px br-bottom-right-8px
                br-bottom-left-md-8px br-bottom-right-md-0px`}
                   id={`credit_note_number_container_${creditNote.id}`}
                   onMouseOver={() => handleDisplayCreditNoteArrowDown(creditNote, true)}
                   onMouseOut={() => handleDisplayCreditNoteArrowDown(creditNote, false)}
                   onClick={(e) => {
                     if (creditNoteRowsPresent(creditNote)) {
                       if (window.innerWidth >= 768) {
                         handleChangeCreditNoteParams({...creditNote, display_content: !creditNote.display_content})
                         e.stopPropagation()
                       }
                       if (!creditNote.display_content)
                         setTimeout(() => scrollHtmlElementIntoView(document, `credit_note_${creditNote.id}_content`, false), 2 * (600 / 3))
                     }
                   }}
              >
                <p className={`my-0 ${creditNote.number ? 'd-none' : ''}`}
                   id={`credit_note_arrow_down_${creditNote.id}`}>
                  <img
                    src={window.location.origin + `/images/icons/white/arrow-${creditNote.display_content ? 'up' : 'down'}.svg`}
                    alt="" width="18px"/>
                </p>

                <b className={`font-size-xxxl-16px ${!creditNote.number ? 'd-none' : ''}`}
                   id={`credit_note_number_${creditNote.id}`}>
                  {creditNote.number}
                </b>
              </div>

              <div className="col-2 col-md-8 col-lg-9 col-xl-10 z-index-10 px-0">
                <div className="d-none d-lg-flex justify-content-end">
                  <CreditNoteDetails
                    creditNote={creditNote}
                    isSuperMiddleman={isSuperMiddleman}
                  />
                </div>
              </div>

              <div className="col-5 col-md-2 col-xl-1 px-0 color-white d-flex justify-content-center align-items-center text-center minH-40px-imp z-index-99 position-relative br-top-right-8px br-bottom-left-8px br-bottom-right-0px br-bottom-left-md-0px br-bottom-right-md-8px"
                   style={{ backgroundColor: invoiceColorState(creditNote.state) }}>
                <div className="my-0 py-0 text-truncate">
                  <b className="color-white text-truncate">
                    {I18n.t(`js.indexCreditNotes.states.${creditNote.state}`)}
                  </b>
                </div>
              </div>

              <div className="col-12 d-lg-none py-2 pr-1">
                <CreditNoteDetails
                  creditNote={creditNote}
                />
              </div>
            </div>

            {
              creditNoteRowsPresent(creditNote) &&
              <div
                className={`row slide-animation-container slide-${creditNote.display_content ? 'down' : 'up'} w-100 p-0 m-0 mt-minus-5px`}
                id={`credit_note_${creditNote.id}_content`}>
                <div className="col-md-2 col-xl-1 d-none d-lg-flex"></div>

                <div
                  className="col-12 col-xl-11 border-left-aiG-light-gray-imp border-right-aiG-light-gray-imp border-bottom-aiG-light-gray-imp border-bottom-radius-8px px-0 pt-1">
                  <div className="row px-0 m-0">
                    <div className="col-9 col-sm-6 col-lg-6 col-xl-9 d-flex justify-content-start align-items-center py-2 bg-aiG-gray3-imp">
                      {I18n.t(`js.invoiceForm.itemsData.description`)}
                    </div>

                    <div className="d-none d-sm-flex col-sm-2 col-lg-2 col-xl-1 justify-content-end align-items-center py-2 bg-aiG-gray3-imp">
                      {I18n.t(`js.invoiceForm.itemsData.quantity`)}
                    </div>

                    <div className="d-none d-sm-flex col-sm-2 col-lg-2 col-xl-1 justify-content-end align-items-center py-2 bg-aiG-gray3-imp">
                      {I18n.t(`js.invoiceForm.itemsData.vat`)}
                    </div>

                    <div className="col-3 col-sm-2 col-lg-2 col-xl-1 d-flex justify-content-end align-items-center py-2 bg-aiG-gray3-imp">
                      {I18n.t(`js.invoiceForm.itemsData.amount`)}
                    </div>

                    {
                      creditNote.credit_note_rows.map((creditNoteRow, i) => {
                        const stripe = i % 2 === 1 ? 'bg-aiG-gray3-imp' : '';
                        return <React.Fragment key={`row_${creditNoteRow.id}`}>
                          <div className={`col-9 col-sm-6 col-lg-6 col-xl-9 d-flex justify-content-start align-items-center py-2 ${stripe}`}>
                            {creditNoteRow.description}
                          </div>

                          <div className={`d-none d-sm-flex col-sm-2 col-lg-2 col-xl-1 justify-content-end align-items-center py-2 ${stripe}`}>
                            <b>{creditNoteRow.quantity}</b>
                          </div>

                          <div className={`d-none d-sm-flex col-sm-2 col-lg-2 col-xl-1 justify-content-end align-items-center py-2 ${stripe}`}>
                            <b>{parseAmount(creditNoteRow.vat_rate, 2, true)}%</b>
                          </div>

                          <div className={`col-3 col-sm-2 col-lg-2 col-xl-1 d-flex justify-content-end align-items-center py-2 ${stripe}`}>
                            <b>{parseAmount(creditNoteRow.amount, 2, true)}{CURRENCY_EURO}</b>
                          </div>
                        </React.Fragment>
                      })
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      )}
    </div>
  );
};

export default CreditNotesList;
